import _ from 'lodash';
const parse = (params) => _.chain(params).replace('?', '').split('&').map(_.partial(_.split, _, '=', 2)).fromPairs().value();
function stringify(obj){
  return _.chain(obj)
    .toPairs() // chuyển thành mảng [[key, value], ...]
    .filter(([_, value]) => value !== undefined) // loại bỏ undefined
    .map(([key, value]) => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(String(value));
      return `${encodedKey}=${encodedValue}`;
    })
    .join('&')
    .value();
}
const QueryString = {
  parse,
  stringify,
};

export default QueryString;
